export function randomNumber(min: number, max: number): number {
  const minRounded = Math.ceil(min);
  const roundedMax = Math.floor(max);
  return Math.floor(Math.random() * (roundedMax - minRounded + 1)) + minRounded;
}
